import { version } from 'package.alias.json'

export default {
  ui: {
    secret: '',
    newDomain: ''
  },
  keys: {
    // 'google': 'supersecretpassword'
  },
  icons: {
    // 'google': 'img/base64:somelettersanddigits'
  },
  secret: '',
  search: '',
  domainInputActive: false,
  domainEditingActive: false,
  version
}
